import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import $ from "jquery";
import Server from '../../../functions/server';
import Loading from '../../loadings';
import { Button, Grid, Dropdown, Image, Form, TextArea, Input } from 'semantic-ui-react';

class Edit extends React.Component {

  state = {
    maxWidth: 'sm',
    fullWidth: true,
    customerTypeOption: [],
    comboOption: [],
  }

  componentDidMount() {
    this.setStates();
    this.getCustomerType();
    this.getCombo();
  }

  componentDidUpdate(props) {
    if (props.editId != this.props.editId) {
      this.setStates();
      this.getCustomerType();
      this.getCombo();
    }
  }

  getCombo() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Offers Details'
    });
    $.ajax({
      type: 'POST',
      url: Server() + 'combo/getallcombo.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setCombo(data);
        } catch (e) {
          context.setState({
            load: false,
          });
        }
      },
      error: function(e)
      {
        alert('Try again!!')
        context.setState({
          load: false
        });
      }
    });
  }

  setCombo(data) {
    console.log(data);
    let context = this;
    var x = [];
    data.map((y) => {
      x.push({key: y.id+"->"+y.combo_name, text: y.id+"->"+y.combo_name, value: y.id});
    });
    try {
      context.setState({
        comboOption: x,
      });
    } catch (e) {}
  }

  setStates() {
    let data = this.props.offer;
    let title;
    let description;
    let start;
    let end;
    let type;
    let image;
    let combo;
    for (var i = 0; i < data.length; i++) {
      if (data[i].id == this.props.editId) {
        title = data[i].title;
        description = data[i].offer;
        start = data[i].start_date;
        end = data[i].end_date;
        type = data[i].customer_type;
        image = data[i].image;
        combo = data[i].cmid;
      }
    }
    if (start == undefined || end == undefined) {

    }
    else {
      start = start.split(" ", 1);
      end = end.split(" ", 1);
      this.setState({
        end: end
      })
    }
    this.setState({
      title: title,
      description: description,
      start: start,
      type: type,
      file: image,
      combo: combo
    })
  }

  close() {
    this.props.handleClose();
  }

  getCustomerType() {
    let context = this;
    context.setState({
      load: true,
      message: 'Getting Executive!!!',
    });
    let data1 = {};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'menucontrol/getcustomertypes.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          context.setCustomerTypes(data);
        } catch (e) {
          context.setState({
            load: false,
          });
        }

      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!')
      }
    });
  }

  onChange = (type) => (f, { value }) => {
    this.setState({ [type]: value })
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    });
  };

  setCustomerTypes(data) {
    let context = this;
    var x = [];
    data.map((y) => {
      x.push({key: y.type_name, text: y.type_name, value: y.id});
    });
    try {
      context.setState({
        customerTypeOption: x,
      });
    } catch (e) {}
  }

  save() {
    let context = this;
    let title = this.state.title;
    let startDate = this.state.start;
    let endDate = this.state.end;
    let customertype = this.state.type;
    let description = this.state.description;

    if (title == '' || title == null || title == undefined) {
      this.setState({ error: "Enter the Title!!!" }); return;
    }
    if (startDate == '' || startDate == null || startDate == undefined) {
      this.setState({ error: "Enter the startDate!!!" }); return;
    }
    if (endDate == '' || endDate == null || endDate == undefined) {
      this.setState({ error: "Enter the endDate!!!" }); return;
    }
    if (description == '' || description == null || description == undefined) {
      this.setState({ error: "Enter the description!!!" }); return;
    }

    var formData = new FormData();
    formData.append('title', title);
    formData.append('offer', description);
    formData.append('start_date', startDate);
    formData.append('end_date', endDate);
    formData.append('id', this.props.editId);
    formData.append('combo', this.state.combo);
    context.setState({
      load: true,
      message: 'Editing Offers',
    });
    $.ajax({
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      url: Server() + 'offer/update.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
        });
        if (data == 1) {
          context.props.success();
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!')
      }
    });

  }


  handleFile = e => {
    this.updateLocalfile(e.target.files[0]);
    this.updatefile(e.target.files[0]);
  }

  updateLocalfile(value) {
    let reader  = new FileReader();
    let context = this;
    reader.addEventListener("load", function () {
      let out = reader.result;
      context.setState({
        file: out,
      });
    }, false);
    if (value) {
      reader.readAsDataURL(value);
    }
  }

  updatefile(image) {
    let context = this;
    let id = this.props.editId;
    var formData = new FormData();
    formData.append('id', id);
    formData.append('file', image);
    this.setState({
      load: true,
      message: 'Updating Image!!!'
    })
    $.ajax({
      type: 'POST',
      processData: false,
      contentType: false,
      data: formData,
      url: Server() + 'offer/imageupdate.php',
      success: function(data)
      {
        context.setState({
          load: false,
        })
        if (data == 1) {
          alert('Image Update successfully!!!!')
        }
      },
      error: function(e)
      {
        context.setState({
          load: false,
        })
        console.log(e);
        alert('Try again!!!!')
      }
    });
  }

  render() {
    return (
      <div>
      <Loading load={this.state.load} message={this.state.message} />
      <React.Fragment>
        <Dialog fullWidth={this.state.fullWidth}
          maxWidth={this.state.maxWidth}  open={this.props.editDialog}
          onClose={this.close.bind(this)} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Edit Offer</DialogTitle>
          <DialogContent>
            <DialogContentText>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <b>Title</b><br/>
                  <Input  value={this.state.title}
                    onChange={this.onChange('title')} fluid />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <Form>
                    <TextArea placeholder='Offer Description'
                      value={this.state.description}
                      onChange={this.onChange('description')}/>
                  </Form>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  Start Date<br/>
                  <input type="date" id="start_date"
                    style={{width: '100%', height: 35 }}
                    value={this.state.start}
                    onChange={this.handleChange('start')} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  End Date<br/>
                  <input type="date" id="end_date"
                    style={{width: '100%', height: 35 }}
                    value={this.state.end}
                    onChange={this.handleChange('end')} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  Select Combo<br/>
                  <Dropdown fluid
                    id="Type" onChange={this.onChange('combo')}
                    search selection options={this.state.comboOption}
                    value={this.state.combo} fluid style={{ borderColor: '#5A9CBB' }} />
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <b>Offer Image</b><br/>
                  <input id='image' type="file" onChange={this.handleFile} style={{display: 'none'}}/>
                  <label htmlFor='image'>
                    <Image src={this.state.file} size='small'
                    style={{width: '100%', height: 300, cursor: 'pointer'}}
                    id='image' />
                  </label>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={16}>
                  <div style={{color: 'red'}}><center>{this.state.error}</center></div>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Button fluid onClick={this.props.handleClose}>Cancel</Button>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={8}>
                  <Button fluid onClick={this.save.bind(this)}>Submit</Button>
                </Grid.Column>
              </Grid>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      </div>
    );
  }
}

export default Edit;
